var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQkrbiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2930",
    "data-name": "Group 2930",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 124.381 141.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3149",
    "data-name": "Rectangle 3149",
    width: 124.381,
    height: 141.889,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2929",
    "data-name": "Group 2929",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M69.22.593A49.943,49.943,0,0,0,54.03.568C37.689,3.038,5.793,11.784,45.451,40.659a28.371,28.371,0,0,0,16.823,5.47,19.452,19.452,0,0,0,3.306-.192A28.245,28.245,0,0,0,78.414,41C92.478,31.121,118.288,8.242,69.22.593",
    fill: "#f48013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M123.787,72.363a49.943,49.943,0,0,0,.025-15.19c-2.47-16.341-11.216-48.237-40.091-8.579a28.371,28.371,0,0,0-5.47,16.823,19.453,19.453,0,0,0,.192,3.306,28.245,28.245,0,0,0,4.934,12.834c9.887,14.064,32.761,39.879,40.41-9.194",
    fill: "#e71200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M.593,72.363a49.943,49.943,0,0,1-.025-15.19c2.47-16.341,11.216-48.237,40.091-8.579a28.371,28.371,0,0,1,5.47,16.823,19.452,19.452,0,0,1-.192,3.306A28.234,28.234,0,0,1,41,81.557C31.121,95.621,8.242,121.436.593,72.363",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M107.24,119.148l-4.669-4.668a53.712,53.712,0,0,1-7.453-8.938C92.3,101.124,87.131,95.95,78.8,89.879a28.388,28.388,0,0,0-16.824-5.47,19.655,19.655,0,0,0-3.305.192,28.256,28.256,0,0,0-12.834,4.934c-14.064,9.887-39.874,32.761,9.194,40.41a49.937,49.937,0,0,0,15.189.025c2.558-.389,5.5-.93,8.485-1.677l9.7,9.7a13.294,13.294,0,0,0,18.835.01,13.48,13.48,0,0,0,3.891-10.04,12.843,12.843,0,0,0-3.885-8.81",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQkrbiz);
export default __webpack_public_path__ + "static/media/Qkrbiz.5246f2268bf6d8c54e1e986a2c5e3d86.svg";
export { ForwardRef as ReactComponent };